/*
Poornima 09/19/2022  2700799562 Fixed GAL-127,132,73,60,104 bugs
Poornima 09/26/2022  2700799562 Fixed global field changes
ashraf  09/29/2022  2700799562 fixed bugs on global fields
adityaa 09/29/2022  2700799562 Implemented save alert for Global Fields module
Poornima 09/29/2022  2700799562 Global field delete usage popup changes
sohel 09/30/2022  2700799562 Global Field List ->Fixed Jira bugs
sohel 09/30/2022  2700799562 Global Field List ->Added Copy Functionality(GAL-311) and Tabel Pay
ashraf 10/04/2022  2700799562 fixed copy, page break issue
ashraf 10/07/2022  2700799562 fixed global field, field group bug fixes
sohel 10/14/2022  2700799562 Global Field ->Added Code Comments.
sohel 10/14/2022  2700799562 Global Field ->Added Code Comments Changes
Suresh 10/17/2022  2700799562 Design Enhancements in global Field Group, List.
Suresh 10/17/2022 2700799562 Text Fields Alignments Fixes in global Field List.
Sohel 10/27/2022 2700799562 removed condition.
Prakash 10/30/2022 2700799562 Renamed  class Styling for Variant-Standard.
akhila 11/1/2022 3031450488 hide toolbar if a row checkbox is selected.
Prakash Gummala 11/02/2022 3031450488 Fixed Responsiveness for 768px.
Suresh Peddavoora 11/03/2022 2700799562 Text Fields Responsive Fixes in Tab Resolution.
akhila 11/07/2022 2700799562 Fixed buttons align center.
Ashraf 11/08/2022 2700799562 Fixed conditional error on reset
Prakash Gummala 11/10/2022 2700799562 Fixed Button Alignments.
Prakash Gummala 11/10/2022 2700799562 Text Field Alignments for Desktop Resolution
Prakash Gummala 14/10/2022 2700799562 Text Field Alignments for 768-1024px resolution.
Prakash Gummala 11/14/2022 2700799562 Text Field Alignments for tab and Laptop-L Resolutions.
Prakash Gummala 11/14/2022 2700799562 Text Field Alignments for tab and Laptop-L Resolutions.
Ashraf 11/18/2022 2700799562 prepopulating category field
Sai Maheshwar 11/18/2022 2700912712 fixed SQL rule clear issue
Ashraf 11/19/2022 2700912712 disabling category field for formula rule
Prakash 11/23/2022  2700912712  Fixed Buttons Responsiveness.
Suresh Peddavoora 11/23/2022 2700912712 Fixed Field Code Textfield Validation Alignments.
Guru Prasad 11/24/2022  2700912712  Fixed Buttons alignments.
Raghu 11/28/2022 2700912712 Responsive Button alignment Fixes .
Gummala Prakash 11/29/2022 2700912712 Fixed Fields Alignments and Responsiveness.
Sohel 12/03/2022 2700799562 Base Category Reset Issue.
Saikrishna 4/12/2022 2700799562 resetted global field list get API data .
lalitha 12/07/2022 2700799562 added Created By field
lalitha 12/07/2022 2700799562 fixed page break issue in created by field
Raghu 12/08/2022 2700799562 Field alignment fixes and responsive fixes
akhila 12/08/2022 2700799562 adding session storage for search items
Akhila 12/09/2022 2700799562 fixed session saerch issue
kavya9reddy 12/09/2022 2700799562 Added createdDate Field
Ashraf 12/09/2022 2700799562 fixed alignment issue
Raghu 12/12/2022 2700799562 Field responsive alignment fixes
Prakash 12/21/2022 2700753823 Fields and Buttons Responsiveness.
Ashraf 01/11/2022 2700753823 conditional renders for audit list
kavyareddy 02/07/2023 2700753823 changes in createdBy dropdown
Dilip 02/13/2023 2700753823 changes in createdBy dropdown
suresh peddavoora 02/21/2023 2700753823 new UI changes for texfields and tables alignments
Prakash 03/16/2023 2700753823 fixed alignments issue in responsive.
Prakash 03/17/2023 2700753823 fixed alignments in Responsive and desktop.
Prakash 12-04-23 2700753823 fixed alignments issue in large screens.
Akhila 06/08/2023 2700753823 created date change to date created field and column
Gireesh 12/11/2023 2692790263 added validation for audit field list code and description in audit field list
*/

import React, {useEffect, useState, useContext} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  getBaseCategory,
  resetData,
  resetGlobalFieldList,
} from '../../../../../redux/reducers/GlobalField/AddFieldList';
import {Button, TextField, FormHelperText} from '@material-ui/core';
import {Form, Formik} from 'formik';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import FieldListSearchTable from './FieldListSearchTable';
import {WarningSnackbar} from '../../../../../components/CustomSnackBar';
import * as Yup from 'yup';
import SelectTabContextProvider from '../../../../../components/SelectTabContext/SelectTabContext';
import {getAllReportCreatedForData} from '../../../../../redux/reducers/ReportMaster';
import {fetchCreatedByDropDownData} from '../../../../../redux/reducers/ReportMaster';
import DateFnsUtils from '@date-io/date-fns';
import {MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import {createdByOptions} from '../../../../../util/CreatedByForOptions';

const AddFieldList = ({
  setTabValue,
  setFieldListRowData,
  setUsageState,
  usageState,
  setRowSelected,
  setIsCopyData,
  StepperFieldList,
  setShowSearch,
  setFieldListCode,
  fieldList,
  setFieldList,
  AuditFieldList,
  isLoading,
  deleteSql,
  field,
  setSelectedList,
  selectedList,
  handleClose,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [searchData, setSearchData] = useState({fieldListCode: fieldList ? fieldList : ''});
  const [auditSearchData, setAuditSearchData] = useState({
    fieldListCode: fieldList ? fieldList : '',
  });

  const [submit, setSubmit] = useState(false);
  const [searchFlag, setSearchFlag] = useState(false);
  const {baseCategoryData, fieldListDataUsage} = useSelector(({addFieldList}) => addFieldList);
  const [customError, setCustomError] = useState(false);
  const [usage, setUsage] = useState(false);
  const [deleteUsage, setDeleteUsage] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isUsage, setIsUsage] = useState(false);
  const [userMetrixDelete, setUserMetrixDelete] = useState(false);
  const {setSample} = useContext(SelectTabContextProvider);
  const [saveData, setSaveData] = useState(selectedList ? selectedList : []);

  const {category} = useSelector(({addRuleGroup}) => addRuleGroup);
  const {createdByData} = useSelector(({reportMaster}) => reportMaster);
  const validationSchema = Yup.object().shape({
    createdDate: Yup.date().typeError('Invalid date format').nullable(),
  });

  const getCategoryObject = (value, data) => {
    const category = data && data?.filter((i) => i?.categoryCode === value);
    if (category?.length > 0) {
      return category[0];
    }
  };
  const filteredCategory = baseCategoryData?.filter(
    (item) => item?.categoryCode !== 'AR' && item?.categoryCode !== 'P',
  );
  useEffect(() => {
    !AuditFieldList && setSearchData({...searchData, fieldListCode: fieldList});
    AuditFieldList && setAuditSearchData({...auditSearchData, fieldListCode: fieldList});
  }, [fieldList]);

  useEffect(() => {
    !AuditFieldList &&
      setSearchData({
        ...searchData,
        baseCategory: category ? getCategoryObject(category, baseCategoryData) : {},
      });
    AuditFieldList &&
      setAuditSearchData({
        ...auditSearchData,
        baseCategory: category ? getCategoryObject(category, baseCategoryData) : {},
      });
  }, [category]);

  // reset data and fetch Base Catagory dropdown data(2700799562)
  useEffect(() => {
    dispatch(resetData());
    dispatch(getBaseCategory());
    setRowSelected && setRowSelected('');
    setSample && setSample(false);
    setIsCopyData && setIsCopyData(false);
  }, []);

  // checking there is usage or not(2700799562)
  useEffect(() => {
    if (fieldListDataUsage?.userMetrix === 'No') {
      deleteUsage ?
        setUserMetrixDelete(false) :
        isDelete ?
          setCustomError(false) :
          setCustomError(true);
      deleteUsage && setIsDelete(true);
      setTimeout(() => {
        setCustomError(false);
      }, 3000);
    } else if (fieldListDataUsage?.userMetrix === 'Yes') {
      deleteUsage && setIsDelete(true);
      deleteUsage && setUserMetrixDelete(true);
      !isDelete && !deleteUsage && setUsageState(true);
      !isDelete && !deleteUsage && setTabValue(2);
      setUserMetrixDelete(true);
    }
  }, [fieldListDataUsage]);

  // reset state(2700799562)
  useEffect(() => {
    !StepperFieldList && setUsageState(false);
    !StepperFieldList && setTabValue(0);
    setIsDelete(false);
    setCustomError(false);
  }, []);
  const SearchSessionFieldList = JSON.parse(sessionStorage.getItem('FieldList'));
  const SearchSessionAuditFieldList = JSON.parse(sessionStorage.getItem('AuditFieldList'));

  // form initialvalues(2700799562)
  const initialValues = {
    fieldListCode: fieldList ? fieldList : '',
    fieldListDescripton: '',
    baseCategory: '',
    createdBy: '',
    createdDate: null,
  };

  // set search Data(2700799562)
  const handleSubmit = (values) => {
    setSearchFlag(true);
    !AuditFieldList && setSearchData(values);
    AuditFieldList && setAuditSearchData(values);
    setSubmit(true);
    if (!StepperFieldList) {
      !AuditFieldList && sessionStorage.setItem('FieldList', JSON.stringify(values));
      AuditFieldList && sessionStorage.setItem('AuditFieldList', JSON.stringify(values));
    }
  };
  useEffect(() => {
    dispatch(getAllReportCreatedForData());
  }, []);
  useEffect(() => {
    if (!AuditFieldList) {
      dispatch(fetchCreatedByDropDownData('fieldlist'));
    } else {
      dispatch(fetchCreatedByDropDownData('auditfieldlist'));
    }
  }, [dispatch]);
  return (
    // Removed Card styles for text fields (2700799562)
    <div>
      <h2 className="search-title">Audit Field Search</h2>
      <div className={` mb-0`}>
        <Formik
          onSubmit={handleSubmit}
          initialValues={
            SearchSessionAuditFieldList && !StepperFieldList && AuditFieldList ?
              SearchSessionAuditFieldList :
              SearchSessionFieldList && !StepperFieldList && !AuditFieldList ?
                SearchSessionFieldList :
                initialValues
          }
          enableReinitialize
          validationSchema={validationSchema}
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleReset,
              handleBlur,
              setFieldValue,
              touched,
              errors,
            } = props;

            return (
              // Changes text field variant from outlined to standard (2700799562)
              <div>
                <Form autoComplete="off">
                  <ErrorBoundaryForComponents>
                    <div className="form-row  standard-field-textfields new-standard-textfields">
                      <div className="col-sm-6 col-xs-6 col-md-4 col-lg-2 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                            popper: classes.popper,
                          }}
                          name="baseCategory"
                          id="baseCategory"
                          size="small"
                          value={values.baseCategory}
                          options={filteredCategory}
                          getOptionDisabled={(option) => option.categoryCode === ''}
                          getOptionLabel={(option) => {
                            return option && option.categoryName ?
                              option.categoryCode === null ?
                                option.categoryName :
                                option.categoryCode + ' - ' + option.categoryName :
                              '';
                          }}
                          onChange={(e, value) => {
                            setFieldValue('baseCategory', value);
                          }}
                          placeholder="Select Base Category"
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={`${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                margin="dense"
                                name="baseCategory"
                                label="Base Category"
                                placeholder="Select Base Category"
                              />
                            </div>
                          )}
                        />
                      </div>
                      <div
                        className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3  ${
                          errors?.fieldListCode?.length > 10 ? 'new-password-fields' : 'form-group'
                        }`}
                      >
                        <TextField
                          margin="dense"
                          className={`${classes.labelName}`}
                          variant="outlined"
                          placeholder={`Enter ${AuditFieldList ? 'Audit' : ''} Field List Code`}
                          label={`${AuditFieldList ? 'Audit' : ''} Field List Code`}
                          name="fieldListCode"
                          value={values?.fieldListCode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.fieldListCode}
                          error={Boolean(touched.fieldListCode && errors.fieldListCode)}
                        />
                        <FormHelperText>
                          {errors.fieldListCode && errors.fieldListCode}
                        </FormHelperText>
                      </div>
                      <div className="col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group">
                        <TextField
                          margin="dense"
                          className={`${classes.labelName}`}
                          variant="outlined"
                          placeholder={`Enter ${
                            AuditFieldList ? 'Audit' : ''
                          } Field List Description`}
                          label={`${AuditFieldList ? 'Audit' : ''} Field List Description`}
                          name="fieldListDescripton"
                          value={values.fieldListDescripton}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-2 col-xl-2 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="createdBy"
                          id="createdBy"
                          size="small"
                          value={values.createdBy}
                          options={createdByData || []}
                          getOptionLabel={(option) => {
                            return option && option?.userLoginName ? option?.userLoginName : '';
                          }}
                          renderOption={(option) => {
                            return createdByOptions(option);
                          }}
                          onChange={(e, value) => {
                            setFieldValue('createdBy', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={`${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                margin="dense"
                                label="Created By"
                                placeholder="Select Created By"
                              />
                            </div>
                          )}
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-2 col-xl-2 form-group start-enddate">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            className={`${classes.labelName}`}
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            fullWidth
                            value={values.createdDate}
                            name="createdDate"
                            onBlur={handleBlur}
                            inputVariant="outlined"
                            helperText=""
                            label="Date Created"
                            onChange={(val) => {
                              setFieldValue('createdDate', val);
                            }}
                            autoOk
                            margin="dense"
                            touched={touched?.createdDate}
                            error={Boolean(touched?.createdDate && errors?.createdDate)}
                          />
                        </MuiPickersUtilsProvider>
                        <FormHelperText variant="outlined">
                          {touched.createdDate && errors.createdDate ? errors.createdDate : ''}
                        </FormHelperText>
                      </div>
                      <div className="col-md-4 col-lg-12 form-group">
                        <div className=" d-flex justify-content-md-start justify-content-lg-center">
                          <Button
                            variant="outlined"
                            className={`mr-1 reset-btn`}
                            onClick={() => {
                              setFieldList && setFieldList('');
                              setSubmit(true);
                              handleReset();
                              dispatch(resetGlobalFieldList());
                              !AuditFieldList &&
                                setSearchData &&
                                setSearchData({...initialValues, fieldListCode: ''});
                              !AuditFieldList && sessionStorage.removeItem('FieldList');
                              AuditFieldList &&
                                setAuditSearchData &&
                                setAuditSearchData({...initialValues, fieldListCode: ''});
                              AuditFieldList && sessionStorage.removeItem('AuditFieldList');
                            }}
                          >
                            Reset
                          </Button>
                          <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
                            Search
                          </Button>
                        </div>
                      </div>
                    </div>
                  </ErrorBoundaryForComponents>
                </Form>
              </div>
            );
          }}
        </Formik>

        <FieldListSearchTable
          searchData={searchData}
          setTabValue={setTabValue}
          searchFlag={searchFlag}
          submit={submit}
          setSubmit={setSubmit}
          setUsage={setUsage}
          usage={usage}
          setFieldListRowData={setFieldListRowData}
          setDeleteUsage={setDeleteUsage}
          setIsDelete={setIsDelete}
          isDelete={isDelete}
          setUsageState={setUsageState}
          usageState={usageState}
          userMetrixDelete={userMetrixDelete}
          setIsUsage={setIsUsage}
          isUsage={isUsage}
          setRowSelected={setRowSelected}
          setUserMetrixDelete={setUserMetrixDelete}
          setIsCopyData={setIsCopyData}
          StepperFieldList={StepperFieldList}
          setShowSearch={setShowSearch}
          setFieldListCode={setFieldListCode}
          setFieldList={setFieldList}
          fieldList={fieldList}
          isReportLoader={isLoading}
          deleteSql={deleteSql}
          AuditFieldList={AuditFieldList}
          field={field}
          auditSearchData={auditSearchData}
          setSelectedList={setSelectedList}
          selectedList={selectedList}
          saveData={saveData}
          setSaveData={setSaveData}
        />
        {customError && (
          <WarningSnackbar errorMsg={'This Audit Field List is not being used anywhere'} />
        )}
      </div>
    </div>
  );
};

export default AddFieldList;
